import { render, staticRenderFns } from "./Past.vue?vue&type=template&id=793bb1b6&scoped=true"
import script from "./Past.vue?vue&type=script&lang=js"
export * from "./Past.vue?vue&type=script&lang=js"
import style0 from "./Past.vue?vue&type=style&index=0&id=793bb1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793bb1b6",
  null
  
)

export default component.exports